// extracted by mini-css-extract-plugin
export default {"paginationBox":"style_paginationBox__8fgq5","mainComponent":"style_mainComponent__OWYGE","pageFilter":"style_pageFilter__2yLtf"};